<template>
  <vue-loading v-if="loading" :active.sync="loading" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>
  <div v-else class="box">
    <div class="row">
      <div class="column col-margin">

        <div class="submit query">
          <button type="button" class="button btn btn-sm btn-primary" v-on:click="submitQuery">Submit Query</button>
        </div>

        <h1 class="title-heading">Insights Tester</h1>

        <h2 class="sub-heading">Query</h2>
        <div>
          <textarea class="input-field" v-model="query"></textarea>
        </div>

        <Transition name="response" appear>
          <textarea v-if="retrieving || response" :class="{'response': !retrieving, 'retrieving': retrieving}" v-model="response" readonly></textarea>
        </Transition>

        <div class="submit instruction">
          <button type="button" class="button btn btn-sm btn-primary" v-on:click="submitInstructions">Update Instructions</button>
        </div>

        <h2 class="sub-heading">Supervisor</h2>
        <div>
          <textarea class="input-field" v-model="supervisor"></textarea>
        </div>

        <h2 class="sub-heading">Costs</h2>
        <div>
          <textarea class="input-field" v-model="costs"></textarea>
        </div>

       <h2 class="sub-heading">Deployments</h2>
        <div>
          <textarea class="input-field" v-model="deployments"></textarea>
        </div>

        <div class="grid grid-cols-1 mt-8 gap-4">
          <Card title="Widget Tester">

            <InsightsDateFilters v-model="selectedDate" @update="updateAllWidgets" />

            <div class="flex items-center justify-between cursor-pointer" @click="alertsOpen = !alertsOpen">
              <h5 class="sub-heading">Alerts Test</h5>
              <svg :class="{'rotate-180': alertsOpen}" class="w-4 h-4 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>

            <Transition name="response" appear>
              <div v-if="alertsOpen" class="mt-2">
                <textarea
                  v-if="alertsRetrieving || alertsResponse"
                  :class="{'response': !alertsRetrieving, 'retrieving': alertsRetrieving}"
                  v-model="alertsResponse"
                  readonly
                ></textarea>
                <textarea v-else readonly>Loading...</textarea>
              </div>
            </Transition>

            <div class="flex items-center justify-between cursor-pointer" @click="deploymentsOpen = !deploymentsOpen">
              <h5 class="sub-heading">Deployments Test</h5>
              <svg :class="{'rotate-180': deploymentsOpen}" class="w-4 h-4 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>

            <Transition name="deploymentResponse" appear>
              <div v-if="deploymentsOpen" class="mt-2">
                <textarea
                  v-if="deploymentsRetrieving || deploymentsResponse"
                  :class="{'response': !deploymentsRetrieving, 'retrieving': deploymentsRetrieving}"
                  v-model="deploymentsResponse"
                  readonly
                ></textarea>
                <textarea v-else readonly>Loading...</textarea>
              </div>
            </Transition>

            <div class="flex items-center justify-between cursor-pointer" @click="costsOpen = !costsOpen">
              <h5 class="sub-heading">Costs Test</h5>
              <svg :class="{'rotate-180': costsOpen}" class="w-4 h-4 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>

            <Transition name="costsResponse" appear>
              <div v-if="costsOpen" class="mt-2">
                <textarea
                  v-if="costsRetrieving || costsResponse"
                  :class="{'response': !costsRetrieving, 'retrieving': costsRetrieving}"
                  v-model="costsResponse"
                  readonly
                ></textarea>
                <textarea v-else readonly>Loading...</textarea>
              </div>
            </Transition>

            <div class="flex items-center justify-between cursor-pointer" @click="base2summaryOpen = !base2summaryOpen">
              <h5 class="sub-heading">Time Series Summary Test</h5>
              <svg :class="{'rotate-180': base2summaryOpen}" class="w-4 h-4 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>

            <Transition name="base2summaryResponse" appear>
              <div v-if="base2summaryOpen" class="mt-2">
                <textarea
                  v-if="base2summaryRetrieving || base2summaryResponse"
                  :class="{'response': !base2summaryRetrieving, 'retrieving': base2summaryRetrieving}"
                  v-model="base2summaryResponse"
                  readonly
                ></textarea>
                <textarea v-else readonly>Loading...</textarea>
              </div>
            </Transition>

            <div class="flex items-center justify-between cursor-pointer" @click="widget1Open = !widget1Open">
              <h5 class="sub-heading">Widget 1 Test</h5>
              <svg :class="{'rotate-180': widget1Open}" class="w-4 h-4 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>

            <Transition name="widget1Response" appear>
              <div v-if="widget1Open" class="mt-2">
                <textarea
                  v-if="widget1Retrieving || widget1Response"
                  :class="{'response': !widget1Retrieving, 'retrieving': widget1Retrieving}"
                  v-model="widget1Response"
                  readonly
                ></textarea>
                <textarea v-else readonly>Loading...</textarea>
              </div>
            </Transition>

            <div class="flex items-center justify-between cursor-pointer" @click="widget2Open = !widget2Open">
              <h5 class="sub-heading">Widget 2 Test</h5>
              <svg :class="{'rotate-180': widget2Open}" class="w-4 h-4 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>

            <Transition name="widget2Response" appear>
              <div v-if="widget2Open" class="mt-2">
                <textarea
                  v-if="widget2Retrieving || widget2Response"
                  :class="{'response': !widget2Retrieving, 'retrieving': widget2Retrieving}"
                  v-model="widget2Response"
                  readonly
                ></textarea>
                <textarea v-else readonly>Loading...</textarea>
              </div>
            </Transition>

            <div class="flex items-center justify-between cursor-pointer" @click="widget3Open = !widget3Open">
              <h5 class="sub-heading">Widget 3 Test</h5>
              <svg :class="{'rotate-180': widget3Open}" class="w-4 h-4 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>

            <Transition name="widget3Response" appear>
              <div v-if="widget3Open" class="mt-2">
                <textarea
                  v-if="widget3Retrieving || widget3Response"
                  :class="{'response': !widget3Retrieving, 'retrieving': widget3Retrieving}"
                  v-model="widget3Response"
                  readonly
                ></textarea>
                <textarea v-else readonly>Loading...</textarea>
              </div>
            </Transition>

          </Card>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import HTTP from '@/common/http'
import { mapGetters } from 'vuex'
import VueLoading from 'vue-loading-overlay'
import Card from '../components/Cards/Card.vue'
import InsightsDateFilters from './InsightsDateFilters.vue'

export default {
  components: {
    VueLoading,
    Card,
    InsightsDateFilters
  },
  props: [
    'id'
  ],
  computed: {
    ...mapGetters([
      'activeType'
    ])
  },
  created: function () {
    this.loading = false
    this.sessionId = this.generateUUID()
  },
  methods: {
    getData: function () {
      this.loading = true
      HTTP.get(`insights`)
        .then((response) => {
          console.log(response.data)
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to get Insights config: ${error.message}`
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    submitQuery: function () {
      this.response = ''
      this.retrieving = true
      let payload = {
        query: this.query,
        supervisor: this.supervisor,
        costs: this.costs,
        deployments: this.deployments
      }
      HTTP.post(`insights/${this.activeType}/${this.id}/${this.sessionId}`, payload, {headers: {'Content-Type': 'application/json'}})
        .then((response) => {
          this.response = response.data.response
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to get Insights config: ${error.message}`
          })
        })
        .finally(() => {
          this.retrieving = false
        })
    },
    submitInstructions: function () {
      this.loading = true
      HTTP.post(`insights-instructions`)
        .then((response) => {
          console.log(response.data)
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to get Insights config: ${error.message}`
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    alertsTest: function () {
      this.alertsRetrieving = true
      const { year, month, day } = this.selectedDate
      HTTP.get(`exposure/widget/${this.id}/${year}/${month}/${day}/alerts`)
        .then((res) => {
          this.alertsResponse = res.data.response
        })
        .catch((err) => {
          console.error('Failed to load alerts:', err)
        })
        .finally(() => {
          this.alertsRetrieving = false
        })
    },
    deploymentsTest: function () {
      this.deplotmentsRetrieving = true
      const { year, month, day } = this.selectedDate
      HTTP.get(`exposure/widget/${this.id}/${year}/${month}/${day}/deployments`)
        .then((res) => {
          this.deploymentsResponse = res.data.response
        })
        .catch((err) => {
          console.error('Failed to load alerts:', err)
        })
        .finally(() => {
          this.deploymentsRetrieving = false
        })
    },
    costsTest: function () {
      this.costsRetrieving = true
      const { year, month, day } = this.selectedDate
      HTTP.get(`exposure/widget/${this.id}/${year}/${month}/${day}/costs`)
        .then((res) => {
          this.costsResponse = res.data.response
        })
        .catch((err) => {
          console.error('Failed to load costs:', err)
        })
        .finally(() => {
          this.costsRetrieving = false
        })
    },
    base2summaryTest: function () {
      this.base2summaryRetrieving = true
      const { year, month, day } = this.selectedDate
      HTTP.get(`exposure/widget/${this.id}/${year}/${month}/${day}/timeSeries`)
        .then((res) => {
          this.base2summaryResponse = res.data.response
        })
        .catch((err) => {
          console.error('Failed to load time series summary:', err)
        })
        .finally(() => {
          this.base2summaryRetrieving = false
        })
    },
    widget1Test: function () {
      this.widget1Retrieving = true
      const { year, month, day } = this.selectedDate
      HTTP.get(`exposure/widget/${this.id}/${year}/${month}/${day}/widget_1`)
        .then((res) => {
          this.widget1Response = res.data.response
        })
        .catch((err) => {
          console.error('Failed to load widget 1:', err)
        })
        .finally(() => {
          this.widget1Retrieving = false
        })
    },
    widget2Test: function () {
      this.widget2Retrieving = true
      const { year, month, day } = this.selectedDate
      HTTP.get(`exposure/widget/${this.id}/${year}/${month}/${day}/widget_2`)
        .then((res) => {
          this.widget2Response = res.data.response
        })
        .catch((err) => {
          console.error('Failed to load widget 2:', err)
        })
        .finally(() => {
          this.widget2Retrieving = false
        })
    },
    widget3Test: function () {
      this.widget3Retrieving = true
      const { year, month, day } = this.selectedDate
      HTTP.get(`exposure/widget/${this.id}/${year}/${month}/${day}/widget_3`)
        .then((res) => {
          this.widget3Response = res.data.response
        })
        .catch((err) => {
          console.error('Failed to load widget 3:', err)
        })
        .finally(() => {
          this.widget3Retrieving = false
        })
    },
    updateAllWidgets: function () {
      this.alertsTest()
      this.deploymentsTest()
      this.costsTest()
      this.base2summaryTest()
      this.widget1Test()
      this.widget2Test()
      this.widget3Test()
    },
    generateUUID: function () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0
        const v = c === 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    }
  },
  mounted () {
    this.alertsTest()
    this.deploymentsTest()
    this.costsTest()
    this.base2summaryTest()
    this.widget1Test()
    this.widget2Test()
    this.widget3Test()
  },
  data () {
    const today = new Date()
    return {
      loading: true,
      retrieving: false,
      alertsRetrieving: false,
      alertsOpen: false,
      deploymentsRetrieving: false,
      deploymentsOpen: false,
      deploymentsResponse: '',
      alertsResponse: '',
      costsRetrieving: false,
      costsOpen: false,
      costsResponse: '',
      base2summaryRetrieving: false,
      base2summaryOpen: false,
      base2summaryResponse: '',
      widget1Retrieving: false,
      widget1Open: false,
      widget1Response: '',
      widget2Retrieving: false,
      widget2Open: false,
      widget2Response: '',
      widget3Retrieving: false,
      widget3Open: false,
      widget3Response: '',
      sessionId: '',
      response: '',
      query: '',
      supervisor: '',
      costs: '',
      deployments: '',
      selectedDate: {
        year: today.getFullYear(),
        month: (today.getMonth() + 1).toString().padStart(2, '0'),
        day: today.getDate().toString().padStart(2, '0')
      }
    }
  }
}
</script>

<style>

h2 {
  font-size: 1.5em;
}

.row {
  width: 100vw;
  display: inline;
}

.col-margin {
  margin-left: 14vw;
  margin-right: 14vw;
}

.title-heading {
  padding-top: 6vh;
  padding-left: 0.5vw;
  top: 6vh;
}

.description {
  padding-left: 0.8vw;
}

.sub-heading {
  padding-left: 0.5vw;
  padding-top: 2vh;
}

.input-field {
  width: 100%;
  height: 80px;
  padding: 12px 20px;
  margin: 0.5vw 0.5vw;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  resize: none;
}

.retrieving {
  width: 100%;
  field-sizing: content;
  padding: 12px 20px;
  margin: 0.5vw 0.5vw;
  box-sizing: border-box;
  border: 2px solid #06D6A0;
  border-radius: 4px;
  background: linear-gradient(135deg, #f8f8f8 25%, rgba(6, 214, 160, 0.3) 25%, rgba(6, 214, 160, 0.3) 50%, #f8f8f8 50%, #f8f8f8 75%, rgba(6, 214, 160, 0.3) 75%);
  background-size: 40px 40px;
  animation: stripe-animation 1s linear infinite;
  resize: none;
  pointer-events: none;
  user-select: none;
  transition: all 200ms;
}

@keyframes stripe-animation {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 40px 40px;
  }
}

.response {
  width: 100%;
  field-sizing: content;
  padding: 12px 20px;
  margin: 0.5vw 0.5vw;
  box-sizing: border-box;
  border: 2px solid #06D6A0;
  border-radius: 4px;
  background-color: #f8f8f8;
  resize: none;
  pointer-events: none;
  user-select: none;
  transition: all 200ms;
}

.response-enter-active {
  transition: transform 200ms, opacity 200ms;
  transition-delay: 200ms;
}
.response-leave-active {
  transition: transform 200ms, opacity 200ms;
}
.response-enter, .response-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(-20px);
}

.submit {
  margin-right: -0.5vw;
  float: right;
  cursor: pointer;
}

.query {
  padding-top: 15vh;
}

.instruction {
  padding-top: 2vh;
}

.rotate-180 {
  transform: rotate(180deg);
}

</style>



// WEBPACK FOOTER //
// src/views/InsightsTester.vue